module.exports = __webpack_public_path__ + "static/media/logo_no_tagline.f664057c.svg";